const { Button } = require('@ui/atoms/design-system');
import { cn } from '@helpers/utils';
import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/outline';
const PrevButton = ({ className, isMobile = false, onClick, disabled }) => (
    <Button
        buttonType="outline"
        className={cn(
            'h-8 w-8 rounded-full p-0',
            isMobile
                ? ''
                : 'absolute -left-12 top-[calc(50%+24px)] -translate-y-1/2 mx-auto text-center ',
            className
        )}
        widthClass="w-8 h-8 !p-0"
        disabled={disabled}
        onClick={onClick}
        buttonText={
            <ArrowLeftIcon className="w-4 h-4 mx-auto text-center text-primary-500" />
        }
    />
);

const NextButton = ({ className, isMobile = false, onClick, disabled }) => (
    <Button
        buttonType="outline"
        className={cn(
            'h-8 w-8 rounded-full p-0',
            isMobile
                ? ''
                : 'absolute -right-12 top-[calc(50%+24px)] -translate-y-1/2',
            className
        )}
        widthClass="w-8 h-8 !p-0"
        disabled={disabled}
        onClick={onClick}
        buttonText={
            <ArrowRightIcon className="w-4 h-4 mx-auto text-center text-primary-500" />
        }
    />
);

export { PrevButton, NextButton };
